<template>
  <span class="material-icons">{{ icon }}</span>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true
    }
  }
}
</script>

<style>

</style>